
<div (contextmenu)="isClickable ? toggleContextMenu($event) : null">
    <ng-content></ng-content>
    <div class="context-menu" #contextMenu *ngIf="contextMenuVisible" [style.right.px]="5" [style.bottom.px]="5">
        <div class="context-item color--gray--2" (click)="actionClick('ANNUALIZE')">
            Annualize interim (A)
        </div>
        <div class="context-item color--gray--2" (click)="actionClick('LAST_YEAR')">
            Use last year’s amount (LY)
        </div>
        <div *ngIf="columnName != 'REVENUE'" class="context-item color--gray--2" (click)="actionClick('LAST_YEAR_PERCENT')">
            Apply prior year’s percentage to the revenue (L%)
        </div>
        <div *ngIf="columnName == 'REVENUE'" class="context-item color--gray--2" (click)="togglePercentDialog()">
            Increase year amount by % (+)
        </div>
        <div *ngIf="columnName != 'REVENUE' && historicalVisible" class="context-item color--gray--2"
            (click)="actionClick('HISTORICAL')">
            Apply historical average percentage of sales to the revenue (H%)
        </div>
    </div>
</div>

<div class="percent-dialog" *ngIf="percentDialogVisible">
    <div class="top-row">
        <div class="action minus noselect" role="button" (click)="decreasePercent()">-</div>

            <number-input [(ngModel)]="revenuePercentage" 
                [classes]="'input-dialog'"
                #revenuePercentageText="ngModel" 
                name="revenue-percentage-text" 
                id="revenue-percentage-text"
                [maxlength]="maxLengthForPercentage"
                (keyup)="keyupForPercentage($event)"
                [allowNegative]="true"></number-input>

        <input type="text" class="input-dialog percentage-input" [value]="'%'" disabled />        
        <div class="action plus noselect" role="button" (click)="increasePercent()">+</div>
    </div>

    <div class="bottom-row">
        <div class="button extra__small__button secondary__button" (click)="togglePercentDialog()">Cancel</div>
        <div class="button extra__small__button primary__button" (click)="acceptPercentDialog()">Accept</div>
    </div>
</div>